import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/image_icon.svg';

const ImageIcon = (props) => (
   <Icon {...props} />
);

export default ImageIcon;
